import { ModuleWithProviders, NgModule } from '@angular/core';
import { APP_CONFIG, AppConfig, DEFAULT_APP_CONFIG } from '../../models';
import { AppConfigService } from '../../services';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor, ErrorInterceptor } from '@app-auth';

/**
 * App module
 */
@NgModule({})
export class MyAppModule {
  /**
   * Api module root providers.
   *
   * Use this method only once under app module to register all required API providers.
   * This is required for all packages to work properly.
   *
   * @param config - partial app configuration
   * @returns module with providers
   */
  static forRoot(config: Partial<AppConfig>): ModuleWithProviders<MyAppModule> {
    const environmentConfig = { ...DEFAULT_APP_CONFIG, ...config };
    const configProvider = {
      provide: APP_CONFIG,
      useValue: environmentConfig,
    };

    return {
      ngModule: MyAppModule,
      providers: [
        configProvider,
        AppConfigService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      ],
    };
  }
}
